
  <template>
    <b-navbar id="navBar">
      <template #brand>
        <b-navbar-item v-if="isCustomer" tag="router-link" :to="{ path: '/customer/home' }" >
          <img
              :src="require('@/assets/images/direct-sign-logo.png')"
              alt="Lightweight UI components for Vue.js based on Bulma"
          >
          <!--TODO:: Modify the link dynamically based on customer and agent-->
        </b-navbar-item>
        <b-navbar-item v-else tag="router-link" :to="{ path: '/' }" >
          <img
              :src="require('@/assets/images/direct-sign-logo.png')"
              alt="Lightweight UI components for Vue.js based on Bulma"
          >
        </b-navbar-item>
      </template>


      <template #end>
        <template v-if="agentLanding">
          <b-navbar-item href="#">
            Why DirectSign
          </b-navbar-item>
          <b-navbar-item href="#">
            Advantages
          </b-navbar-item>
          <b-navbar-item href="#">
            Customers
          </b-navbar-item>
          <b-navbar-item href="#">
            Testimonials
          </b-navbar-item>
          <b-navbar-item href="#">
            Packages
          </b-navbar-item>
          <b-navbar-item href="#">
            Contact us
          </b-navbar-item>
        </template>

      <!-- Agent options -->
        <b-navbar-item tag="div" v-if="isAgent && agentLanding==false">
         <slot name="actionButton"></slot>
        </b-navbar-item>
        <b-navbar-item tag="div" v-if="agentLanding">
          <div class="buttons">
            <b-button rounded outlined class="is-info" @click="$router.push({name:'agentSignin'})">Sign In</b-button>
          </div>
        </b-navbar-item>


        <!-- Customer options -->
        <template v-if="isCustomer && $root.customerData.CustomerSignedIn">
          <b-navbar-item tag="div" >
            <div style="text-align:right">
              <p id="role">{{$root.customerData.role}}</p>
              <p id="username">{{$root.customerData.name}}</p>
            </div>
          </b-navbar-item>

          <b-navbar-item tag="div" >
            <div class="buttons">
              <b-button rounded outlined class="is-primary" @click="logoutCustomer">Logout</b-button>
            </div>
          </b-navbar-item>
        </template>


        <!-- Agent options -->
        <template v-if="isAgent && isAgentSignedIn">
          <b-navbar-item tag="div" >
            <div style="text-align:right">
              <p id="role" v-if="departmentAdmin">Department Admin</p>
              <p id="role" v-if="InternaleStaff">Internal Staff</p>
              <p id="username">{{username}}</p>
            </div>
          </b-navbar-item>

          <b-navbar-item tag="div" >
            <div class="buttons">
              <b-button rounded outlined class="is-info" @click="logout">Logout</b-button>
            </div>
          </b-navbar-item>
        </template>

      </template>
    </b-navbar>
  </template>


<script>
import axios from "axios";

export default {
  name:"nav-bar",

  props:{
    'isAgent':{
      default:false
    },

    'agentLanding':{
      default: false
    },


    'isCustomer':{
      default: false
    },

    // 'isCustomerSignedIn':{
    //   default: false
    // },

    'isAgentSignedIn':{
      default:false
    }

  },

  data(){
    return{
      username:'',
      departmentAdmin:false,
      InternaleStaff:false,
    }
  },

  mounted() {
    if(this.isAgent && this.isAgentSignedIn){
      this.getloggedinUserDetails()
    }

    this.checkRoles()

  },

  methods:{

    checkRoles:function (){
      var role  = this.$root.user_role
      if(role == 1){
        this.departmentAdmin = true
      }else if(role == 2){
        this.departmentAdmin = false
        this.InternaleStaff = true
      }
    },

    logoutCustomer(){
      var component=this
      component.$root.customerData.CustomerSignedIn=false
      component.$router.push({name:'customerSignInHome'})
    },
    logout:function (){
      var component = this

      axios.post(component.$base_url+'/agent/logout', {
        auth_token:component.$root.agentAuthToken

      })
          .then(function (data) {
            var array =[]
            array = data.data
            component.formIsSubmitting = true

            console.log(array.data.name) //username
            if(array.success == true){
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-success'
              })
              component.$router.push({name:'agentSignin'})
            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.go(-1)
            }

          })
          .catch(function (error) {
            console.log(error)
          });
    },

    getloggedinUserDetails:function (){
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken

      })
          .then(function (data) {
            var array =[]
            array = data.data
            component.formIsSubmitting = true

            // console.log(array.data.name)
            if(array.success == true){
              component.username = array.data.name
            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              // component.$router.go(-1)
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            console.log(error)
          });
    }
  }
}
</script>

<style>
  #navBar{
    -webkit-box-shadow: 0px 5px 8px -5px rgba(0,0,0,0.46);
    box-shadow: 0px 5px 8px -5px rgba(0,0,0,0.46);
  }

  #role{
    color: #A5A6B3;
  }

  #username{
    background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
  }

  #username::before{
    content: '';
    display: block;
    border-top: 1px solid #A5A6B3;
    margin-top: 0.5em;
  }
</style>
